'use strict';

var cov_2euthmgy8y = function () {
  var path = 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\plugins\\delta.js',
      hash = '718ff7f5fd05ee113205be9257dbe03a6dcf4ed2',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'C:\\Users\\Bruno\\Documents\\Projects\\SAWAP\\src\\plugins\\delta.js',
    statementMap: {
      '0': {
        start: {
          line: 8,
          column: 0
        },
        end: {
          line: 53,
          column: 3
        }
      },
      '1': {
        start: {
          line: 11,
          column: 32
        },
        end: {
          line: 11,
          column: 66
        }
      },
      '2': {
        start: {
          line: 12,
          column: 4
        },
        end: {
          line: 12,
          column: 71
        }
      },
      '3': {
        start: {
          line: 14,
          column: 24
        },
        end: {
          line: 14,
          column: 56
        }
      },
      '4': {
        start: {
          line: 15,
          column: 25
        },
        end: {
          line: 15,
          column: 52
        }
      },
      '5': {
        start: {
          line: 17,
          column: 4
        },
        end: {
          line: 19,
          column: 5
        }
      },
      '6': {
        start: {
          line: 18,
          column: 6
        },
        end: {
          line: 18,
          column: 63
        }
      },
      '7': {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 23,
          column: 5
        }
      },
      '8': {
        start: {
          line: 22,
          column: 6
        },
        end: {
          line: 22,
          column: 70
        }
      },
      '9': {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 31,
          column: 5
        }
      },
      '10': {
        start: {
          line: 26,
          column: 6
        },
        end: {
          line: 30,
          column: 7
        }
      },
      '11': {
        start: {
          line: 27,
          column: 8
        },
        end: {
          line: 27,
          column: 65
        }
      },
      '12': {
        start: {
          line: 29,
          column: 8
        },
        end: {
          line: 29,
          column: 77
        }
      },
      '13': {
        start: {
          line: 34,
          column: 2
        },
        end: {
          line: 38,
          column: 5
        }
      },
      '14': {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 37,
          column: 5
        }
      },
      '15': {
        start: {
          line: 36,
          column: 6
        },
        end: {
          line: 36,
          column: 19
        }
      },
      '16': {
        start: {
          line: 40,
          column: 2
        },
        end: {
          line: 48,
          column: 5
        }
      },
      '17': {
        start: {
          line: 41,
          column: 4
        },
        end: {
          line: 47,
          column: 5
        }
      },
      '18': {
        start: {
          line: 42,
          column: 6
        },
        end: {
          line: 44,
          column: 7
        }
      },
      '19': {
        start: {
          line: 43,
          column: 8
        },
        end: {
          line: 43,
          column: 52
        }
      },
      '20': {
        start: {
          line: 45,
          column: 11
        },
        end: {
          line: 47,
          column: 5
        }
      },
      '21': {
        start: {
          line: 46,
          column: 6
        },
        end: {
          line: 46,
          column: 53
        }
      },
      '22': {
        start: {
          line: 50,
          column: 2
        },
        end: {
          line: 52,
          column: 5
        }
      },
      '23': {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 51,
          column: 17
        }
      },
      '24': {
        start: {
          line: 56,
          column: 0
        },
        end: {
          line: 64,
          column: 3
        }
      },
      '25': {
        start: {
          line: 57,
          column: 2
        },
        end: {
          line: 63,
          column: 5
        }
      },
      '26': {
        start: {
          line: 58,
          column: 4
        },
        end: {
          line: 62,
          column: 5
        }
      },
      '27': {
        start: {
          line: 59,
          column: 6
        },
        end: {
          line: 59,
          column: 39
        }
      },
      '28': {
        start: {
          line: 61,
          column: 6
        },
        end: {
          line: 61,
          column: 42
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 8,
            column: 18
          },
          end: {
            line: 8,
            column: 19
          }
        },
        loc: {
          start: {
            line: 8,
            column: 24
          },
          end: {
            line: 53,
            column: 1
          }
        },
        line: 8
      },
      '1': {
        name: 'fix_height',
        decl: {
          start: {
            line: 10,
            column: 11
          },
          end: {
            line: 10,
            column: 21
          }
        },
        loc: {
          start: {
            line: 10,
            column: 24
          },
          end: {
            line: 32,
            column: 3
          }
        },
        line: 10
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 34,
            column: 39
          },
          end: {
            line: 34,
            column: 40
          }
        },
        loc: {
          start: {
            line: 34,
            column: 45
          },
          end: {
            line: 38,
            column: 3
          }
        },
        line: 34
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 40,
            column: 19
          },
          end: {
            line: 40,
            column: 20
          }
        },
        loc: {
          start: {
            line: 40,
            column: 25
          },
          end: {
            line: 48,
            column: 3
          }
        },
        line: 40
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 50,
            column: 13
          },
          end: {
            line: 50,
            column: 14
          }
        },
        loc: {
          start: {
            line: 50,
            column: 19
          },
          end: {
            line: 52,
            column: 3
          }
        },
        line: 50
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 56,
            column: 2
          },
          end: {
            line: 56,
            column: 3
          }
        },
        loc: {
          start: {
            line: 56,
            column: 8
          },
          end: {
            line: 64,
            column: 1
          }
        },
        line: 56
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 57,
            column: 32
          },
          end: {
            line: 57,
            column: 33
          }
        },
        loc: {
          start: {
            line: 57,
            column: 38
          },
          end: {
            line: 63,
            column: 3
          }
        },
        line: 57
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 17,
            column: 4
          },
          end: {
            line: 19,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 17,
            column: 4
          },
          end: {
            line: 19,
            column: 5
          }
        }, {
          start: {
            line: 17,
            column: 4
          },
          end: {
            line: 19,
            column: 5
          }
        }],
        line: 17
      },
      '1': {
        loc: {
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 23,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 23,
            column: 5
          }
        }, {
          start: {
            line: 21,
            column: 4
          },
          end: {
            line: 23,
            column: 5
          }
        }],
        line: 21
      },
      '2': {
        loc: {
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 31,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 31,
            column: 5
          }
        }, {
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 31,
            column: 5
          }
        }],
        line: 25
      },
      '3': {
        loc: {
          start: {
            line: 26,
            column: 6
          },
          end: {
            line: 30,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 26,
            column: 6
          },
          end: {
            line: 30,
            column: 7
          }
        }, {
          start: {
            line: 26,
            column: 6
          },
          end: {
            line: 30,
            column: 7
          }
        }],
        line: 26
      },
      '4': {
        loc: {
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 37,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 37,
            column: 5
          }
        }, {
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 37,
            column: 5
          }
        }],
        line: 35
      },
      '5': {
        loc: {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 47,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 47,
            column: 5
          }
        }, {
          start: {
            line: 41,
            column: 4
          },
          end: {
            line: 47,
            column: 5
          }
        }],
        line: 41
      },
      '6': {
        loc: {
          start: {
            line: 42,
            column: 6
          },
          end: {
            line: 44,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 42,
            column: 6
          },
          end: {
            line: 44,
            column: 7
          }
        }, {
          start: {
            line: 42,
            column: 6
          },
          end: {
            line: 44,
            column: 7
          }
        }],
        line: 42
      },
      '7': {
        loc: {
          start: {
            line: 45,
            column: 11
          },
          end: {
            line: 47,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 45,
            column: 11
          },
          end: {
            line: 47,
            column: 5
          }
        }, {
          start: {
            line: 45,
            column: 11
          },
          end: {
            line: 47,
            column: 5
          }
        }],
        line: 45
      },
      '8': {
        loc: {
          start: {
            line: 58,
            column: 4
          },
          end: {
            line: 62,
            column: 5
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 58,
            column: 4
          },
          end: {
            line: 62,
            column: 5
          }
        }, {
          start: {
            line: 58,
            column: 4
          },
          end: {
            line: 62,
            column: 5
          }
        }],
        line: 58
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0],
      '7': [0, 0],
      '8': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

cov_2euthmgy8y.s[0]++;
/**
 * delta - Responsive Admin Theme
 * 2.6.2
 *
 * Custom scripts
 */

$(document).ready(function () {
  cov_2euthmgy8y.f[0]++;

  // Full height of sidebar
  function fix_height() {
    cov_2euthmgy8y.f[1]++;

    var heightWithoutNavbar = (cov_2euthmgy8y.s[1]++, $('body > #wrapper').height() - 61);
    cov_2euthmgy8y.s[2]++;
    $('.sidebard-panel').css('min-height', heightWithoutNavbar + 'px');

    var navbarHeigh = (cov_2euthmgy8y.s[3]++, $('nav.navbar-default').height());
    var wrapperHeigh = (cov_2euthmgy8y.s[4]++, $('#page-wrapper').height());

    cov_2euthmgy8y.s[5]++;
    if (navbarHeigh > wrapperHeigh) {
      cov_2euthmgy8y.b[0][0]++;
      cov_2euthmgy8y.s[6]++;

      $('#page-wrapper').css('min-height', navbarHeigh + 'px');
    } else {
      cov_2euthmgy8y.b[0][1]++;
    }

    cov_2euthmgy8y.s[7]++;
    if (navbarHeigh < wrapperHeigh) {
      cov_2euthmgy8y.b[1][0]++;
      cov_2euthmgy8y.s[8]++;

      $('#page-wrapper').css('min-height', $(window).height() + 'px');
    } else {
      cov_2euthmgy8y.b[1][1]++;
    }

    cov_2euthmgy8y.s[9]++;
    if ($('body').hasClass('fixed-nav')) {
      cov_2euthmgy8y.b[2][0]++;
      cov_2euthmgy8y.s[10]++;

      if (navbarHeigh > wrapperHeigh) {
        cov_2euthmgy8y.b[3][0]++;
        cov_2euthmgy8y.s[11]++;

        $('#page-wrapper').css('min-height', navbarHeigh + 'px');
      } else {
        cov_2euthmgy8y.b[3][1]++;
        cov_2euthmgy8y.s[12]++;

        $('#page-wrapper').css('min-height', $(window).height() - 60 + 'px');
      }
    } else {
      cov_2euthmgy8y.b[2][1]++;
    }
  }

  cov_2euthmgy8y.s[13]++;
  $(window).bind('load resize scroll', function () {
    cov_2euthmgy8y.f[2]++;
    cov_2euthmgy8y.s[14]++;

    if (!$('body').hasClass('body-small')) {
      cov_2euthmgy8y.b[4][0]++;
      cov_2euthmgy8y.s[15]++;

      fix_height();
    } else {
      cov_2euthmgy8y.b[4][1]++;
    }
  });
  // Move right sidebar top after scroll
  cov_2euthmgy8y.s[16]++;
  $(window).scroll(function () {
    cov_2euthmgy8y.f[3]++;
    cov_2euthmgy8y.s[17]++;

    if ($(window).scrollTop() > 0) {
      cov_2euthmgy8y.b[5][0]++;
      cov_2euthmgy8y.s[18]++;

      if ($('.right-sidebar')) {
        cov_2euthmgy8y.b[6][0]++;
        cov_2euthmgy8y.s[19]++;

        $('.right-sidebar').addClass('sidebar-top');
      } else {
        cov_2euthmgy8y.b[6][1]++;
      }
    } else {
        cov_2euthmgy8y.b[5][1]++;
        cov_2euthmgy8y.s[20]++;
        if ($('.right-sidebar')) {
          cov_2euthmgy8y.b[7][0]++;
          cov_2euthmgy8y.s[21]++;

          $('.right-sidebar').removeClass('sidebar-top');
        } else {
          cov_2euthmgy8y.b[7][1]++;
        }
      }
  });

  cov_2euthmgy8y.s[22]++;
  setTimeout(function () {
    cov_2euthmgy8y.f[4]++;
    cov_2euthmgy8y.s[23]++;

    fix_height();
  });
});

// Minimalize menu when screen is less than 768px
cov_2euthmgy8y.s[24]++;
$(function () {
  cov_2euthmgy8y.f[5]++;
  cov_2euthmgy8y.s[25]++;

  $(window).bind('load resize', function () {
    cov_2euthmgy8y.f[6]++;
    cov_2euthmgy8y.s[26]++;

    if ($(document).width() < 769) {
      cov_2euthmgy8y.b[8][0]++;
      cov_2euthmgy8y.s[27]++;

      $('body').addClass('body-small');
    } else {
      cov_2euthmgy8y.b[8][1]++;
      cov_2euthmgy8y.s[28]++;

      $('body').removeClass('body-small');
    }
  });
});